import { Group } from '../group';
import { Organization } from '../organization';
import { Project } from '../project';

export type _OrganizationMembership = {
  organizationId: Organization.Id;
  roleId: Organization.Role.Id;
  samlLoginEnforced: boolean;
  projects: _ProjectMembership[];
};
export namespace _OrganizationMembership {
  export type Props = {
    organizationId: string;
    roleId: string;
    samlLoginEnforced?: boolean;
    projects: _ProjectMembership.Props[];
  };
  export const Construct = (props: Props): _OrganizationMembership => {
    return {
      organizationId: Organization.Id.FromString(props.organizationId),
      roleId: Organization.Role.Id.FromString(props.roleId),
      samlLoginEnforced: props.samlLoginEnforced ?? false,
      projects: props.projects.map(_ProjectMembership.Construct),
    };
  };

  export namespace Assign {
    export type Props = Partial<Pick<_OrganizationMembership, 'roleId' | 'projects' | 'samlLoginEnforced'>>;
    export type Params = {
      cur: _OrganizationMembership;
      props: Props;
    };
  }
  export const Assign = (params: Assign.Params): _OrganizationMembership => {
    const {
      cur,
      props: { roleId, projects, samlLoginEnforced },
    } = params;

    if (!projects || projects.length === 0) {
      return {
        ...cur,
        roleId: roleId ?? cur.roleId,
        samlLoginEnforced: samlLoginEnforced ?? cur.samlLoginEnforced,
      };
    }

    // 同じプロジェクトの membership がすでに存在する場合は上書き
    const projectMap = new Map(cur.projects.map((project) => [project.projectId, project]));
    for (const project of projects) {
      projectMap.set(project.projectId, project);
    }
    return {
      ...cur,
      roleId: roleId ?? cur.roleId,
      samlLoginEnforced: samlLoginEnforced ?? cur.samlLoginEnforced,
      projects: Array.from(projectMap.values()),
    };
  };
}

export type _ProjectMembership = {
  projectId: Project.Id;
  groupId?: Group.Id | null | undefined;
};
export namespace _ProjectMembership {
  export type Props = {
    projectId: string;
    groupId?: string | null | undefined;
  };
  export const Construct = (props: Props): _ProjectMembership => {
    return {
      projectId: Project.Id.FromString(props.projectId),
      groupId: props.groupId ? Group.Id.FromString(props.groupId) : undefined,
    };
  };
}
